import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { useOnClickOutside } from "usehooks-ts";
import CalendarIcon from "assets/icons/calendar.svg?react";
import DropdownLogic from "components/DropdownLogic";
import NotFoundScreen from "components/NotFoundScreen";
import taskService from "api/taskService";
import { ECalendarType } from "dto/IBusyDate";

const SelectCalendar: FC<Props> = ({
  isDisabled = false,
  selected,
  onChoose,
  label,
}) => {
  const { t } = useTranslation();
  const { data: calendarsData, isLoading } = taskService.useGetCalendars();

  const calendars = useMemo(() => {
    if (!calendarsData?.data) return [];
    if (!calendarsData?.data.map) return [];

    return calendarsData?.data.filter(
      (x) => x.type !== ECalendarType.CourtPortal
    );
  }, [calendarsData]);

  useEffect(() => {
    if (calendars?.length) {
      if (!selected) {
        onChoose(calendars.find((c) => c.type === ECalendarType.Nota));
      }
    }
  }, [calendars]);

  const [active, setActive] = useState(false);

  const outsideRef = useRef(null);

  useOnClickOutside(outsideRef, () => {
    if (active) {
      setActive(false);
    }
  });

  return (
    <div ref={outsideRef} className={styles.wrapper}>
      <div
        onClick={(e: any) => {
          if (isDisabled) return;
          const ele = e.target.tagName.toLowerCase();
          const button = e.target.outerHTML.search("button") !== -1;

          if (ele !== "div" || button) {
            return;
          }

          setActive(!active);
        }}
        className={styles.card}
      >
        {selected ? (
          <>
            <CalendarIcon className={styles.icon} /> {selected.name}
          </>
        ) : (
          <>
            <CalendarIcon className={styles.icon} />{" "}
            {label ? label : <>{t("calendar.chooseCalendar")}</>}
          </>
        )}

        {!isDisabled && (
          <FontAwesomeIcon
            onClick={() => {
              setActive(!active);
            }}
            icon={active ? faCaretUp : faCaretDown}
          />
        )}
      </div>

      {active && (
        <DropdownLogic>
          <div className={`${styles.dropdown}`}>
            <div className={styles.list}>
              {calendars.map((member) => (
                <div
                  onClick={() => {
                    setActive(false);
                    onChoose(member);
                  }}
                  key={member.id}
                  className={styles.box}
                >
                  {member.name}
                </div>
              ))}
            </div>
            {calendars.length === 0 && !isLoading && (
              <div className={styles.empty}>
                <NotFoundScreen
                  title={t("emptyStates.notFound")}
                  text={t("emptyStates.noResultsSuffix")}
                  size="normal"
                ></NotFoundScreen>
              </div>
            )}
          </div>
        </DropdownLogic>
      )}
    </div>
  );
};

export default SelectCalendar;
